import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "editable-list__icon",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "editable-list__actions" }
const _hoisted_3 = ["disabled", "aria-label"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-edit",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["disabled", "aria-label"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon icon-delete" }, null, -1)
const _hoisted_8 = [
  _hoisted_7
]

import { getIconComponent } from './icons/utils';

interface ActionButton {
	index: number|string;
	title: string;
	disabled: boolean;
	hidden: boolean;
	onClick: (index: number|string) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditableItem',
  props: {
    edit: {},
    remove: {},
    icon: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("span", {
      class: _normalizeClass([
			'editable-list__text',
			props.icon ? 'editable-list__text--icon': '',
		])
    }, [
      (props.icon)
        ? (_openBlock(), _createElementBlock("span", _hoisted_1, [
            (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(getIconComponent)(props.icon))))
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "default")
    ], 2),
    _createElementVNode("span", _hoisted_2, [
      (!props.edit.hidden)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            class: "button--list-action",
            type: "button",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (props.edit.onClick(props.edit.index))),
            disabled: props.edit.disabled,
            "aria-label": props.edit.title
          }, _hoisted_5, 8, _hoisted_3))
        : _createCommentVNode("", true),
      (!props.remove.hidden)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "button--list-action",
            type: "button",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (props.remove.onClick(props.remove.index))),
            disabled: props.remove.disabled,
            "aria-label": props.remove.title
          }, _hoisted_8, 8, _hoisted_6))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})